import { ScreenType } from '@tmdb-graphql-api/schema/types';
import { type FiltersResponse } from '#components/Filters/types.ts';

export const isFiltersDataStale = (filtersResponse: FiltersResponse | null | undefined, screenType: ScreenType) => {
  if (screenType === ScreenType.Movie) {
    return filtersResponse && Object.keys(filtersResponse).length === 1 && 'genres' in filtersResponse;
  }

  return filtersResponse && Object.keys(filtersResponse).length === 2 && 'certifications' in filtersResponse;
};
